import classNames from 'classnames';
import { memo } from 'react';
import PropTypes from 'prop-types';
import { WIDTH, MODAL_SIZES } from 'shared-modules/constants';
import { Button, InputText, InputNumber, Modal, InfoTooltip, MarginInfo } from '../../../../components';
import styles from './runNow.module.scss';

const RunNow = ({
  isOpen,
  closeModal,
  runNowLogic,
  marginRequired,
  submitSettings,
  needName,
  setsSettings,
  isTradeAP,
}) => {
  const strategySetsError = runNowLogic.errorMessages?.find((item) => item.inputName === setsSettings?.name);

  return (
    <Modal isOpen={isOpen} closeModal={closeModal} title={runNowLogic.modalTitle} size={MODAL_SIZES.WIDTH_400}>
      {needName && (
        <>
          <div className={styles.row}>{runNowLogic.name.label}</div>
          <InputText
            className={styles.row}
            width={WIDTH.PERCENTAGE_100}
            value={runNowLogic.name.get}
            onChange={runNowLogic.name.set}
            name={runNowLogic.name.name}
            validateFunction={runNowLogic.name.validateFunction}
            errorMessages={runNowLogic.errorMessages}
            withErrorTooltip
          />
          <div className={styles.divider} />
        </>
      )}
      {!isTradeAP && (
        <>
          <div className={styles.row}>
            <div className={styles.runNote}>{runNowLogic.setMessages.adjustNote}</div>
          </div>
          <div className={classNames(styles.row)}>
            <div className={styles.row}>
              <span className={styles.setLabel}>{setsSettings.label} </span>
              <InfoTooltip message={setsSettings.info} />
            </div>
            <InputNumber
              value={setsSettings.get}
              onChange={setsSettings.set}
              name={setsSettings.name}
              validateFunction={setsSettings.validateFunction}
              errorMessages={runNowLogic.errorMessages}
              withErrorTooltip
              onlyIntegerAllowed
              minByDecrement={1}
            />
          </div>
          <div className={styles.row}>
            <div className={styles.maxLimitNote}>{runNowLogic.setMessages.maxLimitNote}</div>
          </div>
        </>
      )}
      <MarginInfo className={styles.margin} requiredMargin={marginRequired} />
      {isTradeAP && strategySetsError && <div className={styles.errorText}>{strategySetsError.errorMessage}</div>}
      <div className={styles.divider} />
      {isTradeAP && (
        <div className={styles.tradeAPPriceNote}>
          {runNowLogic.setMessages.tradeAPPriceNotes.map((note) => (
            <div key={note}>{note}</div>
          ))}
        </div>
      )}
      <div className={styles.startNote}>{runNowLogic.setMessages.autoTradeStartNote}</div>
      <div className={styles.buttonArea}>
        <Button
          className={classNames(styles.greenButton)}
          onClick={submitSettings.handler}
          loading={submitSettings.isLoading}
          disabled={submitSettings.isDisabled}
        >
          {submitSettings.label}
        </Button>
      </div>
    </Modal>
  );
};

RunNow.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  runNowLogic: PropTypes.shape({
    modalTitle: PropTypes.string.isRequired,
    name: PropTypes.shape({
      label: PropTypes.string,
      get: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      set: PropTypes.func,
      name: PropTypes.string,
      validateFunction: PropTypes.func,
    }),
    errorMessages: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    setMessages: PropTypes.shape({
      adjustNote: PropTypes.string.isRequired,
      maxLimitNote: PropTypes.string.isRequired,
      autoTradeStartNote: PropTypes.string.isRequired,
      tradeAPPriceNotes: PropTypes.arrayOf(PropTypes.string).isRequired,
    }).isRequired,
  }).isRequired,
  marginRequired: PropTypes.shape({}).isRequired,
  submitSettings: PropTypes.shape({
    handler: PropTypes.func.isRequired,
    isLoading: PropTypes.bool,
    isDisabled: PropTypes.bool.isRequired,
    label: PropTypes.string.isRequired,
  }).isRequired,
  needName: PropTypes.bool,
  setsSettings: PropTypes.shape({
    label: PropTypes.string.isRequired,
    info: PropTypes.string.isRequired,
    get: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    set: PropTypes.func.isRequired,
    name: PropTypes.string.isRequired,
    validateFunction: PropTypes.func.isRequired,
  }).isRequired,
  isTradeAP: PropTypes.bool,
};

RunNow.defaultProps = {
  needName: true,
  isTradeAP: false,
};

export default memo(RunNow);
